import React from "react";

const Text = ({ children, className = "", as, size = "textxl", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`text-dark_blue_secondary font-lora ${className} `} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
